import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import LandLordContext from "../../../context/landlord/LandLordContext";
import AuthContext from "../../../context/auth/AuthContext";
import "react-toastify/dist/ReactToastify.css";
import useTranslator from "../../../hooks/useTranslator";
import { convertCurrencyFormat, haveValue } from "../../../helper/common";
import { Modal } from "react-bootstrap";
import UserIcon from "../../..//assets/img/user-icon.svg";
import workspaceRoleCapabilities, {
  WORKSPACE_ROLES_CAPABILITIES,
} from "../../../Utils/workspaceRoleCapabilities";

const SingleProperty = ({
  property,
  onPropertyAward,
  hideModal,
  setLinkedTenantsPopup,
  loadData,
  setShowIsEditModal,
}) => {
  const { _t } = useTranslator();
  const [show, setShow] = useState(false);
  const [propData, setPropData] = useState({});
  const [showDetailsModal, setShowDetailsModal] = useState(true);

  const handleClose = () => {
    setShowDetailsModal(true);
    setShow(false);
  };
  const handleShow = () => {
    setShowDetailsModal(false);
    setShow(true);
  };

  const [deleteId, setDeleteId] = useState("");

  const showmodal = (propId) => {
    setDeleteId(propId);
    handleShow();
  };

  const {
    floor_number,
    street_number,
    street,
    flat_number,
    postcode,
    muncipality,
    province,
    staircase,
    area,
    property_reference = null,
    bedrooms,
    washrooms,
    report_rent,
  } = property;
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const landLordContext = useContext(LandLordContext);
  const { deleteProperty, updatePropertyDetails, isParentLL, editProperty } =
    landLordContext;
  const [awardConfirmationModal, setAwardConfirmationModal] = useState(false);

  const deleteMyProperty = async (propertyid) => {
    await deleteProperty(propertyid, user?._id);
    handleClose();
    hideModal();
    await loadData();
  };

  const handleOpenDetails = (property) => {
    setPropData(property);
    setLinkedTenantsPopup(true);
  };

  const awardPropertyHandler = async () => {
    try {
      let propertyId = property._id.toString();
      await updatePropertyDetails(propertyId, {
        is_awarded: property.is_awarded === true ? false : true,
      });

      onPropertyAward(propertyId);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {showDetailsModal && (
        <div className="text-left">
          <div className="properties-box remove_box_style">
            <div className="flex-row align-items-center">
              <div>
                <h4>
                  {street} - {street_number}
                </h4>
              </div>
              <div className="d-flex align-items-center custom-gap_css">
                {WORKSPACE_ROLES_CAPABILITIES?.properties?.edit?.includes(
                  user?.current_workspace_role
                ) && (
                  <>
                    <Link
                      onClick={() => {
                        hideModal();
                        setShowIsEditModal(true);
                      }}
                    >
                      <img src="/images/edit-icon-white.svg" alt="" />
                    </Link>
                  </>
                )}
                {WORKSPACE_ROLES_CAPABILITIES?.properties?.delete?.includes(
                  user?.current_workspace_role
                ) && (
                  <Link onClick={() => showmodal(property._id)}>
                    <img
                      style={{ marginLeft: "0px" }}
                      src="/images/delete-icon.svg"
                      alt=""
                    />
                  </Link>
                )}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  style={{ cursor: "pointer" }}
                  onClick={() => hideModal()}
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.7734 1.32064C16.8453 1.24881 16.9022 1.16352 16.9411 1.06966C16.98 0.975805 17 0.875207 17 0.773615C17 0.672022 16.98 0.571424 16.9411 0.477565C16.9022 0.383706 16.8453 0.298423 16.7734 0.226586C16.7016 0.15475 16.6163 0.0977657 16.5224 0.058888C16.4286 0.0200102 16.328 0 16.2264 0C16.1248 0 16.0242 0.0200102 15.9303 0.058888C15.8365 0.0977657 15.7512 0.15475 15.6794 0.226586L8.5 7.40749L1.32064 0.226586C1.24881 0.15475 1.16352 0.0977657 1.06966 0.058888C0.975805 0.0200102 0.875207 7.56923e-10 0.773615 0C0.672022 -7.56923e-10 0.571424 0.0200102 0.477565 0.058888C0.383706 0.0977657 0.298423 0.15475 0.226586 0.226586C0.15475 0.298423 0.0977657 0.383706 0.058888 0.477565C0.0200102 0.571424 -7.56923e-10 0.672022 0 0.773615C7.56923e-10 0.875207 0.0200102 0.975805 0.058888 1.06966C0.0977657 1.16352 0.15475 1.24881 0.226586 1.32064L7.40749 8.5L0.226586 15.6794C0.0815054 15.8244 0 16.0212 0 16.2264C0 16.4316 0.0815054 16.6283 0.226586 16.7734C0.371667 16.9185 0.568439 17 0.773615 17C0.97879 17 1.17556 16.9185 1.32064 16.7734L8.5 9.59251L15.6794 16.7734C15.8244 16.9185 16.0212 17 16.2264 17C16.4316 17 16.6283 16.9185 16.7734 16.7734C16.9185 16.6283 17 16.4316 17 16.2264C17 16.0212 16.9185 15.8244 16.7734 15.6794L9.59251 8.5L16.7734 1.32064Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
            <div className="single-property-modal-divider" />
            <div className="flex-content flexContent">
              <h5 className="single-property-modal-subhead">
                {_t("location")}
              </h5>
              <ul>
                <li>
                  <span>{_t("street")}:</span>
                  <span>{_t("number")}:</span>
                </li>
                <li>
                  <span className="cl-text">
                    {haveValue(street) ? (
                      street
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                  <span className="cl-text">
                    {haveValue(street_number) ? (
                      street_number
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="flex-content flexContent">
              <ul>
                <li>
                  <span>{_t("stairway")}:</span>
                  <span>{_t("floorNumber")}:</span>
                </li>
                <li>
                  <span className="cl-text">
                    {haveValue(staircase) ? (
                      staircase
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                  <span className="cl-text">
                    {haveValue(floor_number) ? (
                      floor_number
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="flex-content flexContent">
              <ul>
                <li>
                  <span>{_t("letter")}:</span>
                  <span>{_t("municipality")}:</span>
                </li>
                <li>
                  <span className="cl-text">
                    {haveValue(flat_number) ? (
                      flat_number
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                  <span className="cl-text">
                    {haveValue(muncipality) ? (
                      muncipality
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="flex-content flexContent">
              <ul>
                <li>
                  <span>{_t("postCode")}:</span>
                  <span>{_t("province")}</span>
                </li>
                <li>
                  <span className="cl-text">
                    {haveValue(postcode) ? (
                      postcode
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                  <span className="cl-text">
                    {haveValue(province) ? (
                      province
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                </li>
              </ul>
            </div>
            <div className="single-property-modal-divider" />
            <div className="flex-content flexContent">
              <h5 className="single-property-modal-subhead">{_t("details")}</h5>
              <ul>
                <li className="row">
                  <span className="col-4" style={{ width: "33.33%" }}>
                    {_t("area")}:
                  </span>
                  <span className="col-4">{_t("bedrooms")}</span>
                  <span className="col-4">{_t("bathrooms")}</span>
                </li>
                <li className="row">
                  <span className="cl-text col-4" style={{ width: "33.33%" }}>
                    {haveValue(area) ? (
                      `${area} m²`
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                  <span className="cl-text col-4">
                    {haveValue(bedrooms) ? (
                      bedrooms
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                  <span className="cl-text col-4">
                    {!haveValue(washrooms) ? (
                      washrooms
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </span>
                </li>
              </ul>
            </div>

            {haveValue(property_reference) && (
              <div className="flex-content flexContent">
                <ul>
                  <li className="property_details_100">
                    <span>{_t("propertyReference")}:</span>
                  </li>
                  <li className="property_details_100">
                    <span className="cl-text w-100">
                      {haveValue(property_reference) ? (
                        property_reference
                      ) : (
                        <span className="noInfoProperty">-</span>
                      )}
                    </span>
                  </li>
                </ul>
              </div>
            )}
            <div className="single-property-modal-divider" />
            <div className="flex-content flexContent">
              <h5 className="single-property-modal-subhead">
                {_t("rentalOverview")}
              </h5>
              <div
                className="d-flex justify-content-between linked_tenant_div linkedTenantDiv"
                onClick={(e) => {
                  handleOpenDetails(property);
                  hideModal();
                }}
              >
                <div className="d-flex justify-content-between align-items-center w-100 flex-wrap-mobile">
                  <div
                    style={{ border: "none", paddingLeft: "0" }}
                    className="single-property-rental-overview"
                  >
                    <span>{_t("estimatedRent")}</span>
                    {haveValue(report_rent) ? (
                      <p>{`€${convertCurrencyFormat(report_rent)} / ${_t("perMonth")}`}</p>
                    ) : (
                      <span className="noInfoProperty">-</span>
                    )}
                  </div>
                  <div className="single-property-rental-overview flex-row justify-content-center align-items-center">
                    <img src={UserIcon} className="thumbnail" />
                    <p>
                      <span style={{ color: "#7F7F7F" }}>
                        {_t("likedTenants")}
                      </span>
                      : {property?.sharedProfilesCount || 0}
                    </p>
                  </div>
                  <div className="single-property-rental-overview">
                    <span>{_t("status")}</span>
                    <p
                      style={{
                        color: !property?.is_awarded ? "#7F7F7F" : "#253837",
                      }}
                    >
                      {property?.is_awarded ? _t("awarded") : _t("unawarded")}
                    </p>
                  </div>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <img src="/images/arrow-right.svg" className="arrow-right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal show={show} className="metermodal " centered onHide={handleClose}>
        <Modal.Body>
          <h4>
            {_t(
              "areYouSureYouWantToDeleteThisPropertyPleaseNoteThatThisActionCannotBeUndone"
            )}
          </h4>
          <div className="auth-form">
            <div className="btngroup row100 gridbar">
              <button
                className="btn btnoutline"
                type="button"
                onClick={(e) => {
                  handleClose();
                }}
              >
                {_t("no")}
              </button>
              <button
                className="btn btngreen"
                onClick={(e) => deleteMyProperty(deleteId)}
              >
                {_t("yes")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={awardConfirmationModal}
        className="metermodal "
        centered
        onHide={() => {
          setAwardConfirmationModal(false);
        }}
      >
        <Modal.Body>
          <h4>{_t("areYouSure")}</h4>
          <div className="auth-form">
            <div className="btngroup row100 gridbar">
              <button
                className="btn btnoutline"
                type="button"
                onClick={() => {
                  setAwardConfirmationModal(false);
                }}
              >
                {_t("no")}
              </button>
              <button
                className="btn btngreen"
                onClick={(e) => awardPropertyHandler()}
              >
                {_t("yes")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SingleProperty;
